import React, { ChangeEvent, forwardRef, useEffect, useState } from 'react';
import { useDebounce } from '@hooks';
import { TextField } from '@components/Common';
import { DebouncedTextFieldProps, TRef } from './DebouncedTextField.types';

const DebouncedTextField = forwardRef(
  (
    {
      value,
      delay,
      placeholder,
      icon,
      inputSize,
      className,
      label,
      type,
      error,
      onSearch,
      ...rest
    }: DebouncedTextFieldProps,
    ref: TRef
  ) => {
    const [currentValue, setCurrentValue] = useState(value);
    const [isSearching, setIsSearching] = useState(false);
    const debouncedValue = useDebounce(currentValue, delay);

    const onTextValueChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
      setIsSearching(true);
      setCurrentValue(target.value);
    };

    useEffect(() => {
      if (isSearching) {
        onSearch?.(debouncedValue);
      }
    }, [debouncedValue]);

    useEffect(() => {
      if (value !== currentValue) {
        setCurrentValue(value);
      }
    }, [value]);

    return (
      <TextField
        {...rest}
        className={className}
        error={error}
        iconLeft={icon}
        inputSize={inputSize}
        label={label}
        placeholder={placeholder}
        ref={ref}
        type={type}
        value={currentValue}
        onChange={onTextValueChange}
      />
    );
  }
);

DebouncedTextField.displayName = 'DebouncedTextField';
export default DebouncedTextField;
